import DashboardLayout from "./layout/DashboardLayout";
import EtherScan from "./etherScan";

const EtherScanComponent = () => {
  return (
    <DashboardLayout>
      <EtherScan />
    </DashboardLayout>
  );
};

export default EtherScanComponent;
